// Shared by MarketingNav, QuizPageNav and UserAvatarMenu so every nav item's
// icon looks identical. Decorative — the label carries the accessible name.
// Hover recolours the text only; the icon stays canopy-500.
export const navIconProps = {
  size: 18,
  strokeWidth: 1.8,
  className: "shrink-0 text-canopy-500",
  "aria-hidden": true,
} as const;

export const navLinkClass =
  "inline-flex items-center gap-2 whitespace-nowrap hover:text-primary transition-colors focus-ring rounded-[var(--radius-sm)]";
